import { Socket as PhoenixSocket, SocketConnectOption } from 'phoenix';

const origin = window.location.origin;
const wsOrigin = origin.replace(/^http/gi, 'ws');

const t0 = performance.now();

// set in index.html by ApiWeb.WebappController
const { token } = window as unknown as { token: string };

// @types/phoenix doesn't know longPollFallbackMs yet, though phoenix 1.7.11
// supports it
const options: Partial<SocketConnectOption> & { longPollFallbackMs: number } = {
  params: { token },
  // Firefox has held a page's WebSocket for over a minute without starting
  // it, with nothing failing, so fall back to long polling (the server allows
  // it on /api_socket). Phoenix keeps using long polling for the rest of the
  // tab's session once it has fallen back
  longPollFallbackMs: 2500,
  logger: (kind: string, msg: string, data: unknown) => console.log(`${(performance.now() - t0).toFixed(0)}ms ${kind}: ${msg}`, data),
};

export const socket = new PhoenixSocket(`${wsOrigin}/api_socket`, options);

// Phoenix remembers a fallback for the rest of the tab's session, so one
// stall made every later load long poll; try the websocket again each load
try { sessionStorage.removeItem('phx:longpoll'); } catch { /* storage blocked */ }

socket.connect();
